import { useAuth } from 'hooks/auth';
import { api } from 'services';

export function useDock() {
  const { token } = useAuth();

  interface DockTimeFramesFilters {
    carrierId: string;
    companyId: string;
    operationTypeId: string;
    warehouseId: string;
    date: string;
    orderTypeId: string;
    duration: string;
    [key: string]: string; // Add index signature
  }

  const getDocksTimeFrames = async (
    filters: DockTimeFramesFilters
  ): Promise<any> => {
    const filtersString = Object.keys(filters)
      .map((key) => `${key}=${filters[key]}`)
      .join('&');

    const { data } = await api.get(
      `/scheduling/docks?${filtersString}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data;
  };

  return { getDocksTimeFrames };
}
